import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Progress,  Loader } from 'semantic-ui-react';
import { fetchSentence, createSentence, updateSentence } from '../../actions/sentence';
import { LargeBrandSentenceEditor, SmallBrandSentenceEditor, BrandSizeNotDefined } from '../../components';

import './BrandSentencesContainer.css';

class BrandSentencesContainer extends Component {
  constructor(props) {
    super(props);
    this.brandId = this.props.brandId;
    
    this.state = {
      progressBar: 1,
      sentence: {},
      isLoading: true,
    };
  }

  componentWillMount = () => {
    this.props.fetchSentence(this.brandId);
  }

  // when component receives props with data from API, will set details to be managed in state
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.sentences && nextProps.sentences !== this.props.sentences) {
      this.setState({
        isLoading: nextProps.sentences.isFetching,
        sentence: nextProps.sentences.sentences ? nextProps.sentences.sentences[0] : {},
      })
    }
  }
  
  handleSaveSentence = (sentenceText) => {
    if (this.state.sentence.id) 
    this.props.updateSentence(this.state.sentence.id, { brandId: this.brandId, text: sentenceText })
    else this.props.createSentence({ brand: this.brandId, text: sentenceText})
    this.handleCancel();
  }
  
  handleCancel = () => {
    this.setState({
      isEditing: false,
      isGeneratingSentence: false,
    });
    //this.props.fetchSentence(this.brandId);
  }

  render = () => {
    const size = this.state.sentence.size ? this.state.sentence.size : null;
    return (
      <div className='sentence-container'>
        {this.state.isLoading ? <Loader active inline='centered' />
        : <div className="autosummary-container">
            <Progress total={1} value={this.state.progressBar} progress />
            <div><strong>Brand Size: </strong> {size} </div>
            
            {size === 'large' && 
              <LargeBrandSentenceEditor
                brandId={this.props.brandId}
                sentence={this.state.sentence}
                onSave={(sentenceText) => this.handleSaveSentence(sentenceText)}
                onCancel={() => this.handleCancel()}
              />
            }

            {size === 'small' &&
              <SmallBrandSentenceEditor
                brandId={this.props.brandId}
                sentence={this.state.sentence}
                onSave={(sentenceText) => this.handleSaveSentence(sentenceText)}
                onCancel={() => this.handleCancel()}
              />
            }

            {size === null && 
              <BrandSizeNotDefined 
                onBackBrandPage={()=> this.props.history.push(`/brandLanding/${this.brandId}`)}
                onBackToGeneral={()=> this.props.history.push(`/brandLanding/${this.brandId}`)}
              />
            }
          </div>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoading: state.sentence.isFetching,
    isErroring: state.sentence.isErroring,
    sentences: state.sentence,
    brand: state.brandInfo,
  };
}

BrandSentencesContainer.propTypes = {
  brandId: PropTypes.string.isRequired
}

export default connect(mapStateToProps, { updateSentence, fetchSentence, createSentence })(BrandSentencesContainer);




// WEBPACK FOOTER //
// ./src/components/Sentences/BrandSentencesContainer.js